import script from "./ModulesVideosComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModulesVideosComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModulesVideosComponent.vue?vue&type=style&index=0&id=24ea2e14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ea2e14"]])

export default __exports__